import { AUDIT_FIELD_LABEL } from '../constants'

export function formatHistoryDate(iso, withSeconds = false) {
    if (!iso) return '—'

    const date = new Date(iso)
    if (Number.isNaN(date.getTime())) return iso

    const pad = (value) => String(value).padStart(2, '0')
    const time = withSeconds
        ? `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
        : `${pad(date.getHours())}:${pad(date.getMinutes())}`

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${time}`
}

export function formatFileSize(bytes) {
    if (!bytes && bytes !== 0) return '—'
    if (bytes < 1024) return `${bytes} Б`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`
    return `${(bytes / 1024 / 1024).toFixed(1)} МБ`
}

export function describeAuditChanges(entry) {
    const changes = entry.changes || {}
    const before = changes.before || null
    const after = changes.after || null

    if (entry.action === 'update' && before && after) {
        const diffs = Object.keys(AUDIT_FIELD_LABEL)
            .filter((key) => String(before[key]) !== String(after[key]))
            .map(
                (key) =>
                    `${AUDIT_FIELD_LABEL[key]}: ${before[key] ?? '—'} → ${after[key] ?? '—'}`
            )

        return diffs.length ? diffs.join('; ') : 'без изменений полей'
    }

    const source = after || before || {}

    return Object.keys(AUDIT_FIELD_LABEL)
        .filter((key) => source[key] !== undefined && source[key] !== null)
        .map((key) => `${AUDIT_FIELD_LABEL[key]}: ${source[key]}`)
        .join('; ')
}

export function getPreviewColumns(rows) {
    if (!rows.length) return []

    return Array.from(new Set(rows.flatMap((row) => Object.keys(row || {}))))
}

export function formatTableCellValue(value) {
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false'
    }

    return value ?? '—'
}
